export enum LoginType {
  UsernamePassword,
  BarcodePin
}


// WEBPACK FOOTER //
// ./src/types/login-type.ts